import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { setMeta } from "../utils/tools";


Vue.use(VueRouter);

// 解决连续点击同一路由报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: "/",
    redirect: '/home'
  },
  {
    path: "/home",
    name: "home",
    // redirect: "/home/personal_center",
    component: () => import("../views/home/home.vue"),
    meta: {
      // title: "首页", // 每页的标题
      // keywords: "首页", // 每页的关键字
      // description: "这是首页", // 每页的描述
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
    }
  },
  {
    path: "/personal_center",
    name: "personal_center",
    component: () => import("../views/personal_center/personal_center.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  //wang_start
  {
    path: "/code",
    name: "code",
    component: () => import("../views/codes/code.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  //wang_end
  // 列表
  {
    path: '/product_list',
    name: 'product_list',
    component: () => import("../views/product_list/product_list.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 字体
  {
    path: "/fonts",
    name: "fonts",
    component: () => import("../views/fonts/fonts.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 演示模板
  {
    path: "/modules",
    name: "modules",
    component: () => import("../views/modules/modules.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 视频
  {
    path: "/videos",
    name: "videos",
    component: () => import("../views/videos/videos.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 音乐
  {
    path: "/audios",
    name: "audios",
    component: () => import("../views/audios/audios.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 音效
  {
    path: "/sound",
    name: "sound",
    component: () => import("../views/sound/sound.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 图片
  {
    path: "/images",
    name: "images",
    component: () => import("../views/images/images.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 图片
  {
    path: "/product_detail",
    name: "product_detail",
    component: () => import("../views/product_detail/product_detail.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 3D
  {
    path: "/dimension",
    name: "dimension",
    component: () => import("../views/dimension/dimension.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 搜索
  {
    path: "/search",
    name: "search",
    component: () => import("../views/search/search.vue"),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要权限的
    }
  },
  // 404
  {
    path: "/404",
    name: "404",
    component: () => import("../views/404/404.vue")
  },
  {
    path: "*", // 此处需特别注意置于最底部
    redirect: "/404"
  }
];

const router = new VueRouter({
  routes
});

// 导航守卫
// to: Route: 即将要进入的目标 路由对象
// from: Route: 当前导航正要离开的路由
// next: Function: 一定要调用该方法来 resolve 这个钩子
// next(): 进行管道中的下一个钩子
// next(false): 中断当前的导航
// next('/') 或者 next({ path: '/' }): 跳转到一个不同的地址
// next(error): (2.4.0+) 如果传入 next 的参数是一个 Error 实例

// 全局前置守卫
router.beforeEach((to, from, next) => {

  // ...
  // console.log(to.meta.title)
  // 修改页面meta，用于网站SEO优化，关键字搜索
  if (to.meta.title) document.title = to.meta.title; // 设置页面标题
  setMeta("keywords", to.meta.keywords); // 设置关键字
  setMeta("description", to.meta.description); // 设置描述
  // 判断是否已登录
  if (to.matched.some(record => record.meta.requireAuth)) {
    // // 判断该路由是否需要权限
    // if (window.sessionStorage.getItem('authorization')) {
    //   // 判断缓存里面是否有 token  //在登录的时候设置它的值
    //   next();
    // } else {
    //   // 未登录
    //   next({ path: "/404" }); // 将跳转的路由path作为参数，登录成功后跳转到该路由
    // }
    next();
  } else {
    window.onscroll = null;
    next();
  }
  // next()
});
// 全局后置守卫,不会接受 next 函数
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
  // ...
});

export default router;
